<template>
  <div class="search_tree">
    <div class="serachBar">
      <!-- <span class="line_icon"></span> -->
      <span class="real-info">{{ $t('mechanism') }}</span>
      <div class="search" :class="indexType ? 'warm-search':''">
        <!-- <el-input :placeholder="$t('pleaseEnterOrganization')" clearable v-model="userName" @focus="handleShow" class="serachBarInput">
        </el-input> -->
        <el-select
          ref="baseOuSelect"
          v-model="userName"
          :placeholder="$t('pleaseEnterOrganization')"
          style="width: 100px"
          class="serachBarInput"
        >
          <el-option :value="selectTree" style="overflow: auto; height: 100%">
            <div class="transition">
              <el-tree
                :data="ouData"
                :props="defaultProps"
                node-key="id"
                default-expand-all
                @node-click="changeCurrent"
                :expand-on-click-node="false"
                highlight-current
                ref="dataConfigTree"
              >
                <span class="custom-tree-node" slot-scope="{ node }">
                  <span class="node-txt">{{ node.data.name }}</span>
                  <!-- <el-tooltip
              class="item"
              effect="dark"
              :content="$t('ClickJumpTThePrecise')"
              placement="right-start"
              v-has="'sys:new:command'"
            >
              <img src="@/icon/ic_share.png" class="editBtn" @click.stop="() => linkIndex(data, node)" />
            </el-tooltip> -->
                </span>
              </el-tree>
            </div>
          </el-option>
        </el-select>
        <!-- <el-button type="primary" class="serachBtn" size="small">
          {{ $t('query') }}
        </el-button> -->
      </div>
    </div>

    <!-- <div class="show_btn" @click="showTree = !showTree">
      {{ showTree ? $t('Stow') : $t('openS') }}
      <img :src="require(showTree ? '@/icon/newBg/up_icon.png' : '@/icon/newBg/down_icon.png')" />
    </div> -->
  </div>
</template>

<script>
import { getOus } from '@/api/UserList'
export default {
  props: {
    indexType: {
      type: String
    }
  },
  data() {
    return {
      userName: '',
      showTree: false,
      ouData: [],
      defaultProps: {
        label: 'name',
        children: 'children',
      },
      handleClick: false,
      selectTree: "",
    }
  },
  methods: {
    linkIndex(data, node) {
      this.$router.push({ path: '/newIndex/newCommand', query: { id: node.data.id } })
      this.$store.commit('currentIndex', 'command')
    },
    handleShow() {
      this.showTree = true
    },
    //点击机构查询
    changeCurrent(item) {
      console.log(item)
      this.userName = item.name
      this.$emit('currentNode', item)
      this.showTree = false
      this.$refs.baseOuSelect.blur()
    },
    // 获取组织机构
    getOus() {
      getOus().then(res => {
        if (res.state === 0) {
          this.ouData = res.data
          if (res.data[0]) {
            this.changeCurrent(res.data[0])
          }
        }
      })
    },
  },
  mounted() {
    this.getOus()
  },
  watch: {
    userName(val) {
    },
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl'
.search_tree
  width: 100%
  height: calc( 100% - 22px)
  font-size 16px
  // padding-top 20px
  margin-left: 20px
  // >>>.el-input
  //   width: 210px !important;
  .serachBar
    display: flex
    align-items: center
    width: 100%
    // height 60px
    line-height: 36px
    pointer-events: auto
    // background: #FFFFFF;
    // box-shadow: 0px 2px 6px 0px rgba(0,54,103,0.1);
    border-radius: 4px;
    .real-info
      color: #333
      font-weight: bold
      margin-right: 10px
    .line_icon
      display inline-block
      content ''
      width 3px
      height 20px
      background-color var(--cockpit-real-info-bg)
      margin-right 7px
      margin-left 10px
      border-radius 1px
    .search
      position relative
      width 76%
      pointer-events: auto
      display: flex
      align-items: center
      .serachBarInput
        width 100%!important
        border-radius: 2px;
      .serachBtn
        border: none;
        margin-left: 10px
        padding 10px!important
      >>>.el-input__inner
        height 36px;/*no*/
        line-height: 36px;/*no*/
      // >>> .el-button
      //   position absolute
      //   // top 50%
      //   right 0
      //   transform: translate(0,-50%)
      //   width: 56px
      //   height: 30px
      //   line-height 30px
      //   padding: 0
      //   background: #00DEFF
      //   border-radius: 2px
      //   color: #00113C
  .transition
    height: 89%
    width 245px
    margin: 0 auto
    pointer-events: auto
    cursor pointer
    .custom-tree-node
      flex 1
      display flex
      align-items center
      justify-content space-between
      // position: relative
      padding-right 20px
      // display: inline-block
      width 90%
      overflow: hidden
      text-overflow: ellipsis
      white-space: nowrap
    .editBtn
      display none
      width 25px
  .show_btn
    width: 60px;/*no*/
    height: 24px;/*no*/
    font-size: 12px
    line-height: 24px;/*no*/
    text-align: center
    color: #0BFCFF
    cursor pointer
    pointer-events: auto
    bg-image-full('~@/icon/newBg/upbg.png')
.warm-search
  width: 80%!important
  >>>.el-input
    width: 290px !important;
>>> .el-tree
  height 100%
  background: var(--new-tree-bg)
  color: var(--new-el-select-dropdown-item)
>>>.el-tree-node
  height: 100%
>>>.el-tree-node__content:hover .editBtn
    display inline-block
>>>.el-input__prefix, >>>.el-input__suffix
  color #fff
>>> .el-tree-node__content
  font-weight: 400
  color: var(--new-el-select-dropdown-item)
.el-select-dropdown
  .el-select-dropdown__list
    .el-select-dropdown__item.hover
      background-color var(--new-tree-bg)
.theme-dark
  .search_tree
    .serachBar
      .real-info
        color: #fff
</style>
